// extracted by mini-css-extract-plugin
module.exports = {"Page":"DiscoveryProvincesDetails_Page__3q5OD","NameGroup":"DiscoveryProvincesDetails_NameGroup__2h1Gh"};